import Vue from 'vue'
// import router from 'vue-router'
// import axios from 'axios';

export default {

  // Site notification display list
  data: [],

  // Is Work In Progress visible?
  wip: {
    showing: false,
    message: '',
    count: 0
  },

  // Add some notification to the site
  add(type, text, ttl) {
    let isThereSome = this.data.filter(notif => {return notif.message == text && notif.type == type})
    console.log('Notification added', type, text)
    // if (isThereSome.length > 0) {
    //   isThereSome[0].timeToLive = (new Date()).getTime() + ((ttl ? ttl : 15) * 1000)
    // } else {
    //   this.data.push({id: this.getId(), type: type, message: text, timeToLive: (new Date()).getTime() + ((ttl ? ttl : 15) * 1000), enableClose: (ttl >= 30)})
    // }
    // this.checkNotif(this)
  },

  checkNotif(that) {
    for (var i = 0; i < that.data.length; i++) {
      // remove old notifications
      if (that.data[i].timeToLive < (new Date()).getTime()) {
        var removed = that.data.splice(i,1)
      }
    }

    if (that.data.length > 0) {
      setTimeout(function (){that.checkNotif(that)}, 1000);
    }
  },

  // Show total window owerlay with Work In Progress information
  showWIP(msg) {
    // console.log('>>  Showing WIP......')
    var that = this;
    // We won't show the progressowerlay immediately. In some case the request might be fast and it would cause unpleasant blinking effect.
    setTimeout(function(){
      if (that.wip.count > 0) {
        that.wip.message = msg;
        that.wip.showing = true;
      }
    }, 100);
    this.wip.count = this.wip.count + 1;
  },

  // Hide total window owerlay with Work In Progress information
  hideWIP(hideAll) {
    // console.log('>>  Hiding WIP......', hideAll)
    if ((hideAll !== undefined && hideAll) || this.wip.count == 1) {
      this.wip.showing = false;
      this.wip.message = '';
      this.wip.count = 0;
    } else {
      this.wip.count = this.wip.count - 1;
    }
  },

  // This gets unique ID of the notification.
  getId() {
    let jti = '', possible = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    for (let i = 0; i < 16; i++) {jti += possible.charAt(Math.floor(Math.random() * possible.length));}
    this.signature = jti;
  },

}
